
import { isMobile } from '../utils/platform';

export default {
  name: 'MarketDataChart',

  computed: {
    chartURL() {
      if (isMobile) {
        return 'https://app.powerbi.com/view?r=eyJrIjoiODI2MTEzODktZjdlNy00YjBiLThlYWItOGFlMGRlMDkwZjYzIiwidCI6ImY5MDFiZGRkLWYzYjAtNDg2OS05ZjcyLWFjNDI1YzNjMzg3NCJ9';
      }
      return 'https://app.powerbi.com/view?r=eyJrIjoiOGE4Y2U1NTctZmU4NC00NTMyLWI0YWItMjlhOWZlMTNkNTJjIiwidCI6ImY5MDFiZGRkLWYzYjAtNDg2OS05ZjcyLWFjNDI1YzNjMzg3NCJ9';
    },
    chartHeight() {
      if (isMobile) {
        return 1800;
      }
      return 980;
    },
    chartWidth() {
      if (isMobile) {
        return 350;
      }
      return 1100;
    },
  },
};
